// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Clientes_BuscaPorNomeResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /clientes/busca_por_nome?q={term}&franchise_id={id}
 *
 * Returns up to 20 active clients matching the search term.
 */
import type { Clientes_BuscaPorNomeRow } from './Clientes_BuscaPorNomeRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Clientes_BuscaPorNomeResponseDados = Clientes_BuscaPorNomeRow[];

export type Clientes_BuscaPorNomeResponse = ApiResponse<Clientes_BuscaPorNomeResponseDados>;

registerResponseContract('Clientes_BuscaPorNomeResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      cliente_id:       { type: 'number',  required: true },
      cliente_nome:     { type: 'string',  required: true },
      cliente_ddi:      { type: 'string',  required: false },
      cliente_ddd:      { type: 'string',  required: false },
      cliente_telefone: { type: 'string',  required: false },
      cliente_email:    { type: 'string',  required: false },
      cliente_cpf:      { type: 'string',  required: false },
    },
  },
})
